export const TEST_OPTIONS = [
  { key: "Option_1", value: 1 },
  { key: "Option_2", value: 2 },
  { key: "Option_3", value: 3 },
  { key: "Option_4", value: 4 },
  { key: "Option_5", value: 5 }
]

// Direct power and cooling load: Use detailed logs.
// Monthly energy consumption: Use bills to estimate profiles.
// One month cooling load: Extrapolate from limited data.

export const LANG_OPTIONS = [
  { name: "English", value: "en" },
  { name: "简体中文", value: "zh" },
  { name: "Español", value: "es" },
  { name: "Deutsch", value: "de" },
  { name: "Français", value: "fr" }
]

export const MONTH_OPTIONS = [
  { key: "Jan", value: 1 },
  { key: "Feb", value: 2 },
  { key: "Mar", value: 3 },
  { key: "Apr", value: 4 },
  { key: "May", value: 5 },
  { key: "Jun", value: 6 },
  { key: "Jul", value: 7 },
  { key: "Aug", value: 8 },
  { key: "Sep", value: 9 },
  { key: "Oct", value: 10 },
  { key: "Nov", value: 11 },
  { key: "Dec", value: 12 }
]

export const LINE_STYLE = { width: 3, shadowColor: "rgba(0,0,0,0.4)", shadowBlur: 10, shadowOffsetY: 10 }
export const COLOR_OPTIONS = ["#152C73", "#1891F6", "#617080", "#BAC0D0", "#61b549", "#bed32e", "#e9a52b", "#f6d009", "#eb5623", "#f18c1e", "#FAF0DF", "#F8D7B5"]
export const TEMPERATURE_CONVERT_MAP = [
  "temp",
  "temperature",
  "hotWaterTemp",
  "zeroHeatTemp",
  "coldestTemp",
  "designWaterTemp",
  "actualWaterTemp",
  "designRatedTemp",
  "designChilledWaterTemp",
  "workingChilledWaterTemp",
  "workingTowerTemp",
  "minDry",
  "maxDry",
  "avgDry",
  "minWet",
  "maxWet",
  "avgWet",
  "peakWater",
  "offPeakWater"
]
export const TEMP_OPTIONS = [
  { name: "℃", value: 1, icon: "degC" },
  { name: "℉", value: 2, icon: "degF" }
]

export const RT_KWC_UNITS = [
  { name: "RT", value: 1 },
  { name: "kWc", value: 2 }
]
export const RTH_KWhC_UNITS = [
  { name: "RTh", value: 1 },
  { name: "kWhc", value: 2 }
]

export const CURRENCY_NULL = { name: "", value: 0, symbol: "--" }
export const CURRENCY_OPTIONS = [
  { name: "USD", value: 150, symbol: "$" },
  { name: "CNY", value: 840, symbol: "￥" },
  { name: "EUR", value: 978, symbol: "€" },
  { name: "GBP", value: 826, symbol: "£" },
  { name: "CAD", value: 124, symbol: "C$" },
  { name: "JPY", value: 392, symbol: "Ұ" },
  { name: "INR", value: 356, symbol: "₹" },
  { name: "SGD", value: 702, symbol: "S$" },
  { name: "HKD", value: 344, symbol: "HK$" },
  { name: "MOP", value: 446, symbol: "MOP$" },
  { name: "TWD", value: 901, symbol: "NT$" },
  { name: "KRW", value: 410, symbol: "₩" },
  { name: "NZD", value: 554, symbol: "NZ$" },
  { name: "AED", value: 784, symbol: "د.إ" },
  { name: "QAR", value: 634, symbol: "ر.ق" },
  { name: "SAR", value: 682, symbol: "ر.س" },
  { name: "KWD", value: 414, symbol: "د.ك" },
  { name: "MYR", value: 458, symbol: "RM" },
  { name: "THB", value: 764, symbol: "฿" },
  { name: "VND", value: 704, symbol: "₫" },
  { name: "AUD", value: 36, symbol: "A$" }
]

export const SPACE_APPLICATIONS = [
  { key: "SpaceCooling", value: 1, icon: "icon-cooling", color: "#1891F6" },
  { key: "SpaceHeating", value: 2, icon: "icon-heating", color: "#eb5623" },
  { key: "DomesticHotWater", value: 3, icon: "icon-hotWater", color: "#f18c1e" }
]

export const BUILD_OPTIONS = [
  {
    key: "LARGE_OFFICE",
    value: 1,
    peak: { hours: 9, boilerUse: 50, waterDemand: 125 },
    offPeak: { hours: 15, boilerUse: 20, waterDemand: 55 }
  },
  {
    key: "MEDIUM_OFFICE",
    value: 2,
    peak: { hours: 9, boilerUse: 50, waterDemand: 125 },
    offPeak: { hours: 15, boilerUse: 20, waterDemand: 55 }
  },
  {
    key: "SMALL_OFFICE",
    value: 3,
    peak: { hours: 9, boilerUse: 50, waterDemand: 125 },
    offPeak: { hours: 15, boilerUse: 20, waterDemand: 55 }
  },
  {
    key: "MALL",
    value: 4,
    peak: { hours: 9, boilerUse: 53, waterDemand: 150 },
    offPeak: { hours: 15, boilerUse: 25, waterDemand: 75 }
  },
  {
    key: "HOTEL",
    value: 5,
    peak: { hours: 8, boilerUse: 65, waterDemand: 450 },
    offPeak: { hours: 16, boilerUse: 35, waterDemand: 150 }
  },
  {
    key: "HOSPITAL",
    value: 6,
    peak: { hours: 14, boilerUse: 60, waterDemand: 650 },
    offPeak: { hours: 10, boilerUse: 50, waterDemand: 250 }
  },
  {
    key: "RESTAURANT",
    value: 7,
    peak: { hours: 8, boilerUse: 65, waterDemand: 450 },
    offPeak: { hours: 16, boilerUse: 35, waterDemand: 150 }
  },
  {
    key: "SCHOOL",
    value: 8,
    peak: { hours: 6, boilerUse: 52, waterDemand: 50 },
    offPeak: { hours: 18, boilerUse: 25, waterDemand: 15 }
  },
  {
    key: "EDUCATIONAL_INSTITUTIONS",
    value: 9,
    peak: { hours: 10, boilerUse: 52, waterDemand: 60 },
    offPeak: { hours: 14, boilerUse: 25, waterDemand: 15 }
  },
  {
    key: "RESIDENTIAL",
    value: 10,
    peak: { hours: 6, boilerUse: 53, waterDemand: 400 },
    offPeak: { hours: 18, boilerUse: 30, waterDemand: 200 }
  },
  {
    key: "OTHERS",
    value: 100,
    peak: { hours: 16, boilerUse: null, waterDemand: null },
    offPeak: { hours: 8, boilerUse: null, waterDemand: null }
  }
]

export const COOLED_OPTIONS = [
  { key: "WaterCooled", value: 1 },
  { key: "AirCooled", value: 2 },
  { key: "WaterCooled_AirCooled", value: 3 }
]

export const PUMP_TYPE_OPTIONS = [
  { key: "ChilledWaterPrimary", value: 1 },
  { key: "ChilledWaterPrimarySecondary", value: 2 },
  { key: "CondenserWaterSys", value: 3 }
]

export const PUMP_HEADER_OPTIONS = [
  { key: "CommonHeader", value: 1 },
  { key: "Dedicated_1_1", value: 2 }
]

export const PRO_BACKGROUND_OPTIONS = [{ key: "projectBackground", value: 0 }]

export const EQPT_TYPE_OPTIONS = [
  { key: "chiller", value: 1 },
  { key: "pump", value: 2 },
  { key: "coolingTower", value: 3 },
  { key: "dryCooler", value: 4 },
  { key: "piping", value: 5 },
  { key: "boiler", value: 6 },
  { key: "others", value: 100 }
]

export const COMPRESSOR_OPTIONS = [
  { key: "wcCentri", value: 1, type: "waterCooled", compressor: "centrifugal" },
  { key: "wcScrew", value: 2, type: "waterCooled", compressor: "screw" },
  { key: "wcRecip", value: 6, type: "waterCooled", compressor: "reciprocating" },
  { key: "wcScroll", value: 7, type: "waterCooled", compressor: "scroll" },
  { key: "acScrew", value: 3, type: "airCooled", compressor: "screw" },
  { key: "acScroll", value: 4, type: "airCooled", compressor: "scroll" },
  { key: "acRecip", value: 5, type: "airCooled", compressor: "reciprocating" }
]

export const PUMP_EQPT_OPTIONS = [
  //Customer modified the display order
  { key: "ChillerWaterPumpPrimaryPump", value: 2 },
  { key: "ChilledWaterPumpSecondaryPump", value: 3 },
  { key: "CondenserWaterPump", value: 1 }
]

export const WEIGHT_TAB_OPTIONS = [
  { key: "ChillerWaterPump", value: 1, param: "chillerPump" },
  { key: "CondenserWaterPump", value: 2, param: "condenserPump" },
  { key: "coolingTower", value: 3, param: "coolingTower" }
]

export const DEGRADATION_RATE = [
  { key: "Degradation_25", value: 0.25 },
  { key: "Degradation_50", value: 0.5 },
  { key: "Degradation_75", value: 0.75 },
  { key: "Degradation_100", value: 1 }
]

export const DRY_COOLER_EQPT_OPTIONS = [
  { key: "CondenserWater", value: 1 }
  // { key: "ChilledWater", value: 2 }
]

export const ENERGY_OPTIONS = [
  { key: "GasFuel", value: 1, unit: "m³", cvRate: 0.2778, emissionsRate: 9.97 },
  { key: "LiquidFuel", value: 2, unit: "liters", cvRate: 0.2778 / 0.85, emissionsRate: 11.86 },
  { key: "ElectricalEnergy", value: 3, unit: "kWh", cvRate: 1, emissionsRate: 1 }
]

export const HEATING_CALC_METHODS = [
  { key: "HeatingCalcMethod_1", value: 1 },
  { key: "HeatingCalcMethod_2", value: 2 }
]

export const HEATING_PROFILE_TABS = [
  { key: "dayHours", value: 1 },
  { key: "energyConsumption", value: 2 },
  { key: "peakUtilization", value: 3 },
  { key: "offPeakUtilization", value: 4 }
]

export const HEATING_SUMMARY_OPTIONS = [
  { key: "heatingLoadPeak", value: 1, unit: "kW" },
  { key: "heatingLoadOffPeak", value: 2, unit: "kW" },
  { key: "minDryBulbTemp", value: 3 },
  { key: "avgDryBulbTemp", value: 4 },
  { key: "coldWaterTempPeak", value: 5 },
  { key: "coldWaterTempOffPeak", value: 6 }
]

export const HEATING_SUBITEM_OPTIONS = [
  { key: "heatingLoadMonthly", value: 1, unit: "kWh" },
  { key: "energyConsumption", value: 2 },
  { key: "energyCharges", value: 3 },
  { key: "co2Emissions", value: 4, unit: "kg CO₂" }
]

export const WEATHER_DATA_TABS = [
  { key: "DryBulbTemp", value: 1, params: ["minDry", "maxDry", "avgDry"] },
  { key: "WetBulbTemp", value: 2, params: ["minWet", "maxWet", "avgWet"] },
  { key: "WaterTemp", value: 3, params: ["peakWater", "offPeakWater"] }
]

export const WEATHER_PARAM_OPTIONS = [
  { key: "MinDryBulbTemp", value: 1, param: "minDry" },
  { key: "MaxDryBulbTemp", value: 2, param: "maxDry" },
  { key: "AvgDryBulbTemp", value: 3, param: "avgDry" },
  { key: "MinWetBulbTemp", value: 4, param: "minWet" },
  { key: "MaxWetBulbTemp", value: 5, param: "maxWet" },
  { key: "AvgWetBulbTemp", value: 6, param: "avgWet" },
  { key: "PeakWaterTemp", value: 7, param: "peakWater" },
  { key: "OffPeakWaterTemp", value: 8, param: "offPeakWater" }
]

export const ESTIMATE_PATHS = [
  { key: "PathA", value: 1 },
  { key: "PathB", value: 2 }
  // { key: "PathC", value: 3 }
]

export const CALCULATE_METHODS = [
  { key: "Method3", value: 3 },
  { key: "Method1", value: 1 }
  // { key: "Method2", value: 2 }
]

export const PERIOD_OFF = [{ key: "Off", value: 0 }]
export const PERIOD_OPTIONS = [
  { key: "Peak", value: 1, param: "peak" },
  { key: "OffPeak", value: 2, param: "offPeak" }
]

export const WEEK_OPTIONS = [
  { key: "Weekday", value: 1, param: "weekday" },
  { key: "Weekend", value: 2, param: "weekend" },
  { key: "WholeWeek", value: 3, param: "wholeWeek" }
]

export const WEEK_PERIOD_OPTIONS = [
  { key: "WeekdayPeak", value: 1, param: "weekdayPeak" },
  { key: "WeekdayOffPeak", value: 2, param: "weekdayOffPeak" },
  { key: "WeekendPeak", value: 3, param: "weekendPeak" },
  { key: "WeekendOffPeak", value: 4, param: "weekendOffPeak" }
  // { key: "WholeWeekPeak", value: 5 },
  // { key: "WholeWeekOffPeak", value: 6 }
]

export const PROFILE_STEP_1 = [{ key: "TabGeneralInfo" }]
export const COOLING_PATH_A_STEPS = [
  { key: "TabPeriod", param: ["hr", "period", "chCount"] },
  // { key: "TabBaseMonth" },
  { key: "TabLoadCapacity", param: ["maxLoad", "percent", "capacity"] },
  { key: "TabEstimateCoolingLoad", action: "Estimating", icon: "icon-estimate" },
  { key: "TabCoolingLoadRes" },
  { key: "TabReferChillerCfg" },
  { key: "TabEstimatePower", action: "Estimating", icon: "icon-estimate" },
  { key: "TabPowerRes", param: ["hr", "peak", "offPeak"] }
  // { key: "TabWeightedPower" }    //
]

export const COOLING_PATH_B_STEPS = [
  { key: "TabReferChillerCfg" },
  // { key: "TabRunningDaysHours", param: ["days", "peak", "offPeak"], title: ["runningDays", "peakHours", "offPeakHours"] },
  { key: "TabRunningHours", param: ["peak", "offPeak"], title: ["peakHours", "offPeakHours"] },
  { key: "TabEnergyConsumption" },
  { key: "TabEstimatePower", action: "Estimating", icon: "icon-estimate" },
  { key: "TabPowerRes" },
  { key: "TabEstimateCoolingLoad", action: "Estimating", icon: "icon-estimate" },
  { key: "TabCoolingLoadRes" }
]
export const OBJECTIVE_MENUS = [{ key: "Objective", path: "/project/objective" }]

export const PRE_MENUS = [
  { key: "PlantProfile", path: "/project/preRetrofit/plantCfg" },
  { key: "SiteObservation", path: "/project/preRetrofit/observation" },
  { key: "EquipmentSpecification", path: "/project/preRetrofit/equipment" },
  { key: "WeatherProfile", path: "/project/preRetrofit/weather" },
  { key: "Profile", path: "/project/preRetrofit/profile" },
  { key: "Analysis", action: "Analyzing", icon: "icon-analysis", animation: "rotate" },
  { key: "DataPreview", path: "/project/preRetrofit/preview" },
  { key: "GenerateReport", action: "Generating", icon: "icon-ppt", animation: "output" }
]

// 系统信息搭建步骤
export const SYSTEM_CONFIG_TABS = [
  { name: "系统信息", key: "系统信息", param: "" },
  { name: "旧机配置", key: "旧机配置", param: "" },
  { name: "新机配置", key: "新机配置", param: "" }
]

// 室外机安装可行性分析步骤
export const INSTALL_ODU_TABS = [
  { name: "旧外机信息", key: "旧外机信息", param: "" },
  { name: "新外机信息", key: "新外机信息", param: "" },
  { name: "其他信息", key: "其他信息", param: "" }
]

// 室内机安装可行性分析步骤
export const INSTALL_IDU_TABS = [
  { name: "旧内机信息", key: "旧外机信息", param: "" },
  { name: "新内机信息", key: "新外机信息", param: "" }
]

// VRF 能耗分析搭建步骤
export const ENEGRYT_COMS_TABS = [
  { name: "分析方法", key: "分析方法", param: "" },
  { name: "负荷信息", key: "负荷信息", param: "" },
  { name: "运行设置", key: "运行设置", param: "" },
  { name: "投资回报", key: "投资回报", param: "" }
]

export const COOLING_CHART_OPTIONS = [
  { key: "powerRes", value: 1 },
  { key: "loadRes", value: 2 }
]

export const PROFILE_TABS = [
  { key: "Configuration", value: 1 },
  { key: "ProfileList", value: 2 }
]



// WEBPACK FOOTER //
// ./src/utils/options.js